import React, { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import InformationCard from '../../../../../../../shared/components/InformationCard';
import CustomSkeleton from './subComponents/CustomSkeleton';

const Client = ({
    vehicles: { vehicle, fetching }
}) => {
    const { t } = useTranslation(["home", "users", "vehicles"]);
    const vehicleOptions = useMemo(() => (
        vehicle.owner ?
            [
                {
                    label: `${t("home:name")}:`,
                    value: `${vehicle.owner.name} ${vehicle.owner.last_name}`
                },
                {
                    label: `${t("users:rut")}:`,
                    value: vehicle.owner.legal_id
                },
                {
                    label: `${t("users:email")}:`,
                    value: vehicle.owner.email
                }
            ]
            : []
    ), [vehicle, t]);

    return (
        <>
            {
                (fetching || Object.keys(vehicle).length > 0) &&
                <InformationCard
                    title={t("home:client")}
                    options={vehicleOptions}
                    loading={fetching}
                    customSkeleton={<CustomSkeleton />}
                    flexDirectionOption="column"
                    row
                />
            }
        </>

    );
};

export default memo(Client);
